export default () => {
    'use strict';

    const validateModalForm = (form: HTMLFormElement, submitBtn: HTMLButtonElement) => {
        const requiredInputs = form?.querySelectorAll('[required]') as NodeListOf<HTMLInputElement>;
        let isValid = true;

        // Validate required fields
        requiredInputs.forEach(requiredInput => {
            if (!requiredInput.reportValidity()) {
                isValid = false;
                requiredInput.classList.add('is-invalid', 'has-error');
                requiredInput.setAttribute('aria-invalid', 'true');
            } else {
                requiredInput.classList.remove('is-invalid', 'has-error');
                requiredInput.removeAttribute('aria-invalid');
            }
        })

        // Focus on the first invalid field
        const firstInvalidInput = form.querySelector('input.is-invalid') as HTMLInputElement;
        firstInvalidInput?.focus();

        return isValid;
    }

    const clearModalInputs = (modalForm: HTMLFormElement) => {
        modalForm.reset();
        const inputs = modalForm.querySelectorAll('input') as NodeListOf <HTMLInputElement>;
        inputs.forEach(input => {
            input.classList.remove('is-invalid', 'has-error')
        })
    }

    const onExitModalOpen = (e: Event) => {
        const modal = e.target as HTMLElement;
        const modalImg = modal.querySelector('img') as HTMLImageElement;
        if (modalImg.src) modalImg.src = modalImg.dataset.src ?? '';
        const modalId = modal?.getAttribute('id') ?? '';
        const modalForm = modal?.querySelector('[data-custom-modal-form]') as HTMLFormElement;
        const submitBtn = modal?.querySelector('#submit-btn-' + modalId) as HTMLButtonElement;

        if(modalForm) clearModalInputs(modalForm);

        submitBtn?.addEventListener('click', (e) => {
            if (!validateModalForm(modalForm, submitBtn)){
                e.preventDefault();
            } else {
                setTimeout(() => {
                    window.bootstrap.Modal.getOrCreateInstance(modal).hide();
                }, 300)
            }
        })
    }

    // Move every document modal at the end of main content and remove duplicates
    const modals = document.querySelectorAll('.modal')
    let addedModals: (string | null)[] = [];
    modals.forEach(modal => {
        const modalId = modal.getAttribute('id');
        if (!addedModals.includes(modalId)) {
            document.body.append(modal);
            addedModals.push(modal.getAttribute('id'))
        } else {
            modal.remove();
        }
        const modalType = modal.getAttribute('data-modal-type');
        if (modalType === 'exitModal') {
            modal.addEventListener('show.bs.modal', onExitModalOpen)
        }
    })

    // Validate if a modal has to be opened on page enter
    const modalCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("triggerModal="))
        ?.split("=")[1];
    const leaveModalSlug = document.querySelector('[data-leave-modal]')?.getAttribute('data-leave-modal') ?? '';

    if (modalCookie && !leaveModalSlug) {
        const modal = document.querySelector(`[data-modal-slug = "${modalCookie}"]`)
        if (modal) {
            window.bootstrap.Modal.getOrCreateInstance(modal).show();
            modal.addEventListener('hide.bs.modal', () => {
                // Remove trigger modal cookie
                document.cookie = 'triggerModal=; Max-Age=0';
            })

        }
    }
}
